import React from "react";
import "./login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "./logo.png";
import loginPic from './loginPic.png'
import { HiUserCircle } from "react-icons/hi";
import { FaLock } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { AiFillTwitterCircle } from "react-icons/ai";
const LoginPage = () => {
  return (
    <>
    <div className="wholeLogin">
      <div className="login-header-logo">
        <img src={logo} alt="image error" />
        {/* <DarkMode className="darkIcon" /> */}
      </div>{" "}
      <div className="LoginContainer container-fluid">
        <div className="Login-Left-Side">
          <img src={loginPic} alt="error" /> 
        </div>{" "}
        <div className="Login-Right-Side container ">
          <div className="loginContent container">
            <h1   
              style={{
                fontFamily:"Itim",
              
                fontWeight: "400",
                fontStyle:"normal"
              }}
            >
              {" "}
              Login{" "}
            </h1>{" "}
            <p> Welcome back! </p> <p> Please Login to continue ... </p>{" "}
          </div>{" "}
          <form className="login-form container">
            <div className="textbox" >
              <input  id="txt"  type="email" placeholder="Email or Mobile Number" />
              <span>
                {" "}
                <HiUserCircle
                  style={{
                    color: "#154666",
                    fontSize: "25px",
                  }}
                />
              </span>
            </div>{" "}
            <div className="textbox">
              <input type="password" placeholder="Password" />
              <span>
                {" "}
                <FaLock
                  style={{
                    color: "#154666",
                    fontSize: "25px",
                  }}
                />
              </span>
            </div>
            <div className="Submit-Btn   ">
              <button type="submit" className="hvr-bounce-to-bottom">
                {" "}
                Login{" "}
              </button>{" "}
            </div>{" "}
          </form>{" "}
          <div className="login_icon">
            <p className="have-account">
              {" "}
              Don 't have an account? <a href="#"> Sign up</a>
            </p>{" "}
            <div className="or">
              <small> or Create account </small>
            </div>{" "}
            <div className="Loign-suing-icons">
              <FaFacebook
                style={{
                  fontSize: "30px",
                  color: "#4267B2",
                }}
              />{" "}
              <FcGoogle
                style={{
                  fontSize: "34px",
                }}
              />{" "}
              <AiFillTwitterCircle
                style={{
                  fontSize: "34px",
                  color: "#1DA1F2",
                }}
              />{" "}
            </div>{" "}
          </div>
        </div>{" "}
      </div>{" "}
    </div>
    </>
  );
};

export default LoginPage;
